import React from 'react';
import JobOpportunityCard from './JobOpportunityCard';
import MobileSwiper from '@/components/mobile/MobileSwiper';
import SeoSwiper from '@/components/swiper/SeoSwiper';
import { useClintMediaQuery } from '@/utils/hooks';
import { JobOptionType } from '@/components/job-title/search-area/JobTitleSearch';
import { CityOption } from '@/context/city';

export type JobOpportunityType = {
  company: {
    id: string;
    name: string;
    logo: null | string;
    industry: { id: string; name: string };
  };
  id: string;
  name: string;
  education: string;
  experience: string;
  salary: string;
  location: CityOption | null;
  job_title: JobOptionType | null;
  qualification: string;
  position: string;
  description: string;
  encrypted_url: string;
  source_type: string;
};

interface Props {
  data: JobOpportunityType[];
  chunkSize?: number;
  mobileChunkSize?: number;
  slideClassName?: string;
  className?: string;
  noSwiper?: boolean;
  dataEleGroup?: string;
}

const JobOpportunityPanel = (props: Props) => {
  const {
    data,
    className = '',
    chunkSize = 12,
    mobileChunkSize = 4,
    slideClassName = 'grid gap-y-4 grid-rows-4 grid-cols-1 tablet:grid-cols-4 tablet:grid-rows-3',
    noSwiper = false,
    dataEleGroup,
  } = props;
  const isMobile = useClintMediaQuery();
  if (noSwiper)
    return (
      <div
        className={
          isMobile
            ? slideClassName
            : `grid tablet:gap-x-4 tablet:gap-y-6 ${slideClassName}`
        }
      >
        {data.map((item) => (
          <JobOpportunityCard
            key={item.id}
            data={item}
            dataEleGroup={dataEleGroup}
          />
        ))}
      </div>
    );

  const SwiperComponent = isMobile ? MobileSwiper : SeoSwiper;
  const swiperProps = {
    tag: 'div',
    chunkData: data,
    chunkSize: isMobile ? mobileChunkSize : chunkSize,
    slideClassName: slideClassName,
    swiperEle: (item: JobOpportunityType) => {
      return (
        <JobOpportunityCard
          key={item.id}
          data={item}
          dataEleGroup={dataEleGroup}
        />
      );
    },
  };
  return (
    <div className={`w-full m-0 ${className}`}>
      <SwiperComponent {...swiperProps} />
    </div>
  );
};

export default JobOpportunityPanel;
